import React, { Component } from 'react';
import { connect } from 'react-redux';
import Input from 'react-toolbox/lib/input';
import Dropdown from 'react-toolbox/lib/dropdown';
import Checkbox from 'react-toolbox/lib/checkbox';
import DatePicker from '~/components/DatePicker';
import { list } from '~/actions/actions';

const defaults = {};

class ShippedStatsSettings extends Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      outdata: {
        ...defaults,
        ...props.indata
      }
    };
  }

  componentDidMount() {
    list(this.props.dispatch, this.context.apiClient);
    this.onChange();
  }

  onChange() {
    this.props.onChange(this.state.outdata);
  }

  setOutdataValue(property, value) {
    this.setState(
      { outdata: { ...this.state.outdata, [property]: value } },
      this.onChange
    );
  }

  setOutdataValues(obj) {
    this.setState(
      { outdata: { ...this.state.outdata, ...obj } },
      this.onChange
    );
  }

  render() {
    const periods = [
      { value: 'today', label: 'Today' },
      { value: 'yesterday', label: 'Yesterday' },
      { value: 'last_week', label: 'Last week' },
      { value: 'last_month', label: 'Last month' },
      { value: 'fixed_date', label: 'Fixed date' }
    ];
    return (
      <div>
        <Input
          value={this.state.outdata.title}
          onChange={val => this.setOutdataValue('title', val)}
          label="Title"
        />
        <Dropdown
          onChange={val =>
            this.setOutdataValues({ period: val, from: null, to: null })
          }
          source={periods}
          value={this.state.outdata.period}
          label="Period"
        />
        {this.state.outdata.period === 'fixed_date' && (
          <div className="clearFix">
            <div className="pullLeft" style={{ width: '50%' }}>
              <DatePicker
                label="From"
                locale="us"
                sundayFirstDayOfWeek
                onChange={from => {
                  this.setOutdataValue('from', from);
                }}
                value={this.state.outdata.from}
              />
            </div>
            <div className="pullRight" style={{ width: '50%' }}>
              <DatePicker
                label="To"
                locale="us"
                sundayFirstDayOfWeek
                onChange={to => {
                  this.setOutdataValue('to', to);
                }}
                value={this.state.outdata.to}
              />
            </div>
          </div>
        )}
        <Checkbox
          checked={this.state.outdata.showDateFields}
          label="Show date fields"
          onChange={val => this.setOutdataValue('showDateFields', val)}
        />
        <Checkbox
          checked={this.state.outdata.hideOrderList}
          label="Hide order/box list"
          onChange={val => this.setOutdataValue('hideOrderList', val)}
        />
        <Dropdown
          onChange={val => this.setOutdataValue('actionId', val)}
          source={this.props.actions}
          value={this.state.outdata.actionId}
          label="Shipped action"
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  actions: state
    .getIn(['actions', 'items'])
    .map(action => ({
      value: action.get('id'),
      label: action.get('name')
    }))
    .valueSeq()
    .toArray()
});

export default connect(
  mapStateToProps,
  null,
  null,
  { pure: false }
)(ShippedStatsSettings);



// WEBPACK FOOTER //
// ./app/widgets.new/ShippedStats/settings.js